import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';
import type { CaptchaChallenge } from '../components/RecaptchaField';
import { clientError, toAppError } from '../lib/errorCodes';
import { notify } from '../components/notify/notify';

export type CaptchaProof = { captchaId: string; captchaAnswer: number };

export function useCaptcha() {
  const [challenge, setChallenge] = useState<CaptchaChallenge | null>(null);
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState<CaptchaProof | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setVerified(null);
    try {
      const { data } = await api.get<{ captchaId?: string; id?: string; prompt?: string; question?: string }>('/captcha/challenge');
      const id = data.captchaId || data.id || '';
      const prompt = data.prompt || data.question || '';
      setChallenge(id && prompt ? { id, prompt } : null);
      if (!id || !prompt) notify.appError(clientError('CAPTCHA_UNAVAILABLE'), { id: 'captcha-load' });
    } catch (err) {
      setChallenge(null);
      const info = toAppError(err);
      notify.appError({ ...clientError('CAPTCHA_UNAVAILABLE'), requestId: info.requestId }, { id: 'captcha-load' });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { challenge, loading, verified, setVerified, reload };
}
